import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const messaging = {
  namespaced: true,
  state: {
    currentChannel: '',
    isOpenChat: '',
    closingChannel: '',
    activeChannels: [],
    selectedDriverChannel: '',
    chatOpenedByOperator: ''
  },
  getters,
  mutations,
  actions
}
